export const DELETE_DOCUMENTS_SUCCESS = 'DELETE_DOCUMENTS_SUCCESS';

export const deleteDocumentsSuccess = (ids) => ({
    type: DELETE_DOCUMENTS_SUCCESS,
    payload: { ids },
});
